
export * from '../../frontend-js-dependencies-web/__liferay__/exports/pkce-challenge.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/pkce-challenge.js';
export default __default__;
